import { useState } from "react";
import { Box, Paper, TextField, Button, Chip, Typography, Grid } from "@mui/material";
export const ShareConfig = ({ shareMessage, setShareMessage }) => {
    const [newMessage1, setNewMessage1] = useState(shareMessage[0] || "");
    const [newMessage2, setNewMessage2] = useState(shareMessage[1] || "");

    const getPreviewText = (msg, isSubmissionsPage = false) => {
        const previewValues = {
            link: `https://thanq.page/thanq/${isSubmissionsPage ? "" : "profile"}`,
            name: "Thanq User",
            office: "Bangalore",
        };
        return msg
            .replace("%link%", previewValues.link)
            .replace(/%name%/g, previewValues.name)
            .replace(/%office%/g, previewValues.office)
            .replace(/\\n/g, "\n");
    };

    return (
        <Paper sx={{ position: "relative", mt: 4, p: 2 }}>
            <Grid container direction={"row"} spacing={2}>
                <Grid direction={"row"} sx={{ flex: 1, maxWidth: 600 }} item>
                    <Box sx={{ mb: 2, p: 1, borderRadius: 1 }}>
                        <Grid spacing={1} container direction={"column"}>
                            <strong>Available placeholders:</strong>
                            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                                <Chip
                                    label="%link%"
                                    color="primary"
                                    variant="outlined"
                                    onClick={() => {}}
                                />{" "}
                                - The review link
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                                <Chip
                                    label="%name%"
                                    color="primary"
                                    variant="outlined"
                                    onClick={() => {}}
                                />{" "}
                                - The Users name
                            </Typography>
                            <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
                                <Chip
                                    label="%office%"
                                    color="primary"
                                    variant="outlined"
                                    onClick={() => {}}
                                />{" "}
                                - The users's office
                            </Typography>
                        </Grid>
                    </Box>
                    <TextField
                        label="Share template for Profile page"
                        fullWidth
                        margin="dense"
                        multiline
                        minRows={2}
                        value={newMessage1?.replace(/\\n/g, "\n")}
                        onChange={(e) => setNewMessage1(e.target.value)}
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Share template for Submissions page"
                        fullWidth
                        margin="dense"
                        multiline
                        minRows={2}
                        disabled
                        value={newMessage2?.replace(/\\n/g, "\n")}
                        onChange={(e) => setNewMessage2(e.target.value)}
                        sx={{ mb: 2 }}
                    />
                    <Button
                        variant="contained"
                        disabled={newMessage1?.replace(/\n/g, "\\n") === shareMessage[0]}
                        onClick={() => {
                            setShareMessage([
                                newMessage1?.replace(/\n/g, "\\n"),
                                newMessage2?.replace(/\n/g, "\\n"),
                            ]);
                        }}
                        sx={{ mb: 2 }}
                    >
                        Save
                    </Button>
                </Grid>
                <Box sx={{ mt: 2, maxWidth: 300 }}>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Android Share Preview Profile:
                    </Typography>
                    <Paper
                        variant="outlined"
                        sx={{ p: 2, background: "#f5f5f5", color: "black", mb: 2 }}
                    >
                        <Typography variant="body2" style={{ whiteSpace: "pre-line" }}>
                            {getPreviewText(newMessage1)}
                        </Typography>
                    </Paper>
                    <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Android Share Preview Submissions:
                    </Typography>
                    <Paper variant="outlined" sx={{ p: 2, background: "#f5f5f5", color: "black" }}>
                        <Typography variant="body2" style={{ whiteSpace: "pre-line" }}>
                            {getPreviewText(newMessage2, true)}
                        </Typography>
                    </Paper>
                </Box>
            </Grid>
        </Paper>
    );
};
